export default __webpack_public_path__ + "4e2803c80329a4ae892b83beb7473d62.woff2";